(function(){"use strict";try{if(typeof document<"u"){var n=document.createElement("style");n.appendChild(document.createTextNode(`._playIcon_3xgwd_1{background:transparent;border:0 none;cursor:pointer;left:50%;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%)}._playIcon_3xgwd_1 span{border-radius:50%;color:var(--neu-plain-0);font-size:78px;transition-duration:.2s;transition-property:transform;font-variation-settings:normal}._playIcon_3xgwd_1:hover i,._playIcon_3xgwd_1:focus i{transform:scale(1.3)}._opacity_3xgwd_23{opacity:.77}
._extendedDropdown_17k1l_1 .unit-dropdown .dropdown-menu{max-height:clamp(150px,80vh,500px)!important}
@media (min-width: 992px){._overlay_1tz1r_2{margin-top:-6rem}}@media (min-width: 992px){._corpOverlay_1tz1r_8{margin-top:-8rem}}._hideEmpty_1tz1r_13:has(>div:empty){display:none}
._richText_1ghed_1 a:not(._neu-button_1ghed_1){color:var(--neu-plain-0);font-size:14px;text-decoration:none}._richText_1ghed_1 a:not(._neu-button_1ghed_1):hover,._richText_1ghed_1 a:not(._neu-button_1ghed_1):focus{background:none;text-decoration:underline;color:var(--neu-plain-0);border:none}._richText_1ghed_1 strong{font-weight:600}._richText_1ghed_1 hr{border:none;background-color:var(--neu-plain-0);height:1px;width:100%;margin:20px 0}a._corpLinks_1ghed_24{color:var(--neu-plain-0);text-decoration:none}a._corpLinks_1ghed_24:hover,a._corpLinks_1ghed_24:focus{background:none;text-decoration:underline;color:var(--neu-plain-0);border:none}._containerFlex_1ghed_37{padding:35px}@media (min-width: 992px){._containerFlex_1ghed_37{padding:35px 72px}}
@media (min-width: 576px){._standaloneSearch_10kr5_2{min-width:20rem}}._standaloneSearch_10kr5_2 .unit-dropdown{width:100%}._standaloneSearch_10kr5_2 .neu-form--support:empty{display:none}._standaloneSearch_10kr5_2 .unit-wrapper:before{all:unset}._standaloneSearch_10kr5_2 .neu-form__native{padding:var(--form-padding);padding-right:calc(40px + var(--neu-spacer-3));min-width:18rem}._standaloneSearch_10kr5_2 .neu-form__native::-webkit-search-cancel-button{margin-top:.1rem}@media (min-width: 992px){._corporateStandalone_10kr5_25{min-width:19rem}._corporateStandalone_10kr5_25 label{color:var(--neu-plain-0)}}._standaloneSearch_10kr5_2+.input-spinner{--feedback-padding-right: calc(40px + var(--neu-spacer-3));--feedback-padding-bottom: var(--neu-spacer-3)}._standaloneButton_10kr5_37.with-label{top:calc(1.375rem + var(--neu-spacer-2))}`)),document.head.appendChild(n)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { jsx as s, Fragment as L, jsxs as S } from "react/jsx-runtime";
import { useState as E, useRef as $, useEffect as j, useCallback as M } from "react";
import { useI18n as R } from "next-localization";
import { c as l } from "../../chunks/clsx.OuTLNxxd.js";
import { NeuIcon as U } from "@hcahealthcaredpx/neutron-react";
import { NextImage as V } from "@sitecore-jss/sitecore-jss-nextjs";
const v = "rel=0&enablejsapi=1", A = "_playIcon_3xgwd_1", C = "_opacity_3xgwd_23", y = {
  playIcon: A,
  opacity: C
}, B = ({
  video: t,
  preview: i,
  title: x,
  imageClasses: m,
  onPlay: e
}) => {
  const [N, u] = E(!!i), p = $(null), { t: _ } = R(), r = t && (t.includes("youtube") || t.includes("youtu.be"));
  j(() => {
    u(!!i);
  }, [t, i]);
  const I = M(() => {
    var f;
    const d = p.current;
    if (!d) return;
    r && ((f = d.contentWindow) == null || f.postMessage('{"event": "listening"}', "https://www.youtube.com"));
    const n = (a) => {
      var w, g, h, b;
      if (!(a.origin !== "https://mediaconnect.app.medcity.net" && a.origin !== "https://www.youtube.com")) {
        if (r && typeof a.data == "string")
          try {
            const c = JSON.parse(a.data);
            ((w = c == null ? void 0 : c.info) == null ? void 0 : w.playerState) === 1 && (e == null || e(), window.removeEventListener("message", n));
          } catch {
            return;
          }
        ((g = a.data) == null ? void 0 : g.event) === "playerStatusChanged" && ((b = (h = a.data) == null ? void 0 : h.msg) == null ? void 0 : b.status) === "Playing" && (e == null || e(), window.removeEventListener("message", n));
      }
    };
    return window.addEventListener("message", n), () => window.removeEventListener("message", n);
  }, [r, e]);
  if (!t) return null;
  let o = r ? `${t}${t.includes("?") ? "&" : "?"}${v}` : t;
  return o = i ? `${o}${o.includes("?") ? "&" : "?"}autoplay=1` : o, /* @__PURE__ */ s(L, { children: N ? /* @__PURE__ */ S("div", { className: "position-relative", children: [
    /* @__PURE__ */ s(
      "div",
      {
        className: l(
          "h-100 neu-bg-main-70 position-absolute right-0 top-0 w-100",
          i && y.opacity
        ),
        children: /* @__PURE__ */ s(
          "button",
          {
            className: y.playIcon,
            "aria-label": _("Accessibility.Video.Play"),
            onClick: () => {
              u(!1), e && e();
            },
            children: /* @__PURE__ */ s(U, { color: "main", name: "play_circle", size: "3x" })
          }
        )
      }
    ),
    i ? /* @__PURE__ */ s(
      V,
      {
        field: i,
        className: l("w-100 h-100 object-fit-cover", m),
        ariaLabel: "Video preview"
      }
    ) : /* @__PURE__ */ s(
      "div",
      {
        className: l("ratio-16x9", m),
        "aria-label": "Video preview"
      }
    )
  ] }) : /* @__PURE__ */ s("div", { className: "position-relative ratio-16x9", children: /* @__PURE__ */ s(
    "iframe",
    {
      ref: p,
      width: "100%",
      height: "100%",
      src: o,
      className: "position-absolute left-0 top-0",
      title: x,
      allowFullScreen: !0,
      allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      onLoad: I
    }
  ) }) });
};
export {
  B as MediaConnectVideo
};
